import * as io from "socket.io-client";

let socket_url = "";

if (window.location.hostname == "bikersecodelivery.com.br" || window.location.hostname == "www.bikersecodelivery.com.br") {
  socket_url = "https://laravel.bikersecodelivery.com.br";
} else if (window.location.hostname == "localhost") {
  socket_url = "http://localhost:6001";
} else if (window.location.hostname == "teste.bikersecodelivery.com.br") {
  socket_url = "https://teste-laravel.bikersecodelivery.com.br";
}

const createSocketInstance = function({ token }) {
  return io(socket_url, {
    cors: { credentials: false, origins: ["*"] },
    auth: { token },
    reconnectionDelay: 2000,
    maxReconnectionAttempts: Infinity,
    transports: ["websocket"]
  });
};

export default createSocketInstance;
